export const vpnEnterpriseContactUrl = 'https://protonvpn.com/business/contact';
